import React from 'react'
import { useUserStore } from '../stores/useUserStore'
import { Button } from '../components/ui/button/Button'
import { useNavigate } from 'react-router'
export function Profile() {
    const { user, removeCredentials } = useUserStore();
    const navigate = useNavigate();
    function handleLogout() {
        removeCredentials();
        navigate('/');
    }
    return (
        <div>
            <h1>Профиль</h1>
            <p>{user?.username}</p>
            <Button width={"w-455"} variant={"dark-blue"} onClick={handleLogout}> Выйти</Button>
        </div>
    )
}
